// extracted by mini-css-extract-plugin
module.exports = {"closeIssueModel":"style_closeIssueModel__1fihN"};